export default __webpack_public_path__ + "static/media/COVID-Icons-1.7d1bc84f.svg";